module.exports = __webpack_public_path__ + "static/media/platzi.6cadbf7e.png";